const initState = {
    url: 'https://foreignwr-server.onrender.com/',
    // url: 'http://localhost:5050/'
}

const ApiReducer = (state=initState, action)=>{
    return state
}

export default ApiReducer